module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "background": "#7BADD6"
    },
    attrs: {
      "id": "lab_background",
      "width": "100%",
      "viewBox": "0 0 1280 572"
    }
  }, [_c('g', {
    staticClass: "lab",
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('rect', {
    attrs: {
      "id": "lab_bg",
      "width": "1280",
      "height": "572",
      "fill": "#7BADD6",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-linecap": "square",
      "stroke-width": "2",
      "d": "M-0.5,504 L1279.5,504"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "65",
      "x": "78",
      "y": "463",
      "fill": "#6090B8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4E7CA2",
      "d": "M118,468 L138,468 C140.761424,468 143,470.238576 143,473 C143,475.761424 140.761424,478 138,478 L118,478 C115.238576,478 113,475.761424 113,473 C113,470.238576 115.238576,468 118,468 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "80",
      "height": "38",
      "x": "88",
      "y": "484",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "110",
      "height": "15",
      "x": "73",
      "y": "448",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "80",
      "height": "130",
      "x": "152",
      "y": "398",
      "fill": "#5585AE"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M153,398 L173,398 L160.128771,325.639554 C156.728796,324.831674 153.162598,324.831674 149.430176,325.639554 C145.697754,326.447434 142.392562,327.783097 139.5146,329.646543 L153,398 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M172.205444,328.940141 L192.202935,329.361088 L193.243518,396.340433 C190.060161,397.782216 186.559484,398.462679 182.741487,398.381821 C178.923489,398.300964 175.424166,397.620502 172.243518,396.340433 L172.205444,328.940141 Z",
      "transform": "scale(1 -1) rotate(-2 -20651.584 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M200.707336,321.334804 L219.418683,324.634119 L221.412871,398.041301 C218.229514,399.682629 214.728837,400.457269 210.91084,400.365221 C207.092842,400.273173 203.593519,399.498533 200.412871,398.041301 L200.707336,321.334804 Z",
      "transform": "scale(1 -1) rotate(-10 -3913.664 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#5585AE",
      "d": "M224.799124,329.547968 L234.542825,331.797479 L235.872092,398.102374 C234.5447,399.544157 233.084993,400.22462 231.49297,400.143763 C229.900946,400.062905 228.441804,399.382443 227.115542,398.102374 L224.799124,329.547968 Z",
      "transform": "scale(1 -1) rotate(-13 -2971.904 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#A2C5E2",
      "d": "M153,398 L179,398 C169.971029,355.310221 165.347286,333.190073 165.128771,331.639554 C157.119421,331.45993 148.581364,330.795592 139.5146,329.646543 L153,398 Z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "1134 357 912 357 912 232 1134 232",
      "transform": "rotate(180 1023 294.5)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M1119.26756,345 C1119.61337,344.402199 1120.25972,344 1121,344 C1122.10457,344 1123,344.895431 1123,346 C1123,347.104569 1122.10457,348 1121,348 C1120.25972,348 1119.61337,347.597801 1119.26756,347 L926.732436,347 C926.386626,347.597801 925.740282,348 925,348 C923.895431,348 923,347.104569 923,346 C923,344.895431 923.895431,344 925,344 C925.740282,344 926.386626,344.402199 926.732436,345 L1119.26756,345 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "196",
      "height": "1",
      "x": "925",
      "y": "325.4",
      "fill": "#FFF",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "196",
      "height": "1",
      "x": "925",
      "y": "304.8",
      "fill": "#FFF",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "196",
      "height": "1",
      "x": "925",
      "y": "284.2",
      "fill": "#FFF",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "196",
      "height": "1",
      "x": "925",
      "y": "263.6",
      "fill": "#FFF",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "196",
      "height": "1",
      "x": "925",
      "y": "243",
      "fill": "#FFF",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "line_graph_first_group"
    }
  }, [_c('path', {
    attrs: {
      "id": "line_graph_first_path",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M929.12 324.54l46.14 -39.52 48.08 19.8 46.97 -62.55 47.24 84.27"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "cx": "1117",
      "cy": "326",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_first_graph_4",
      "cx": "1070",
      "cy": "243",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_first_graph_3",
      "cx": "1023",
      "cy": "305",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_first_graph_2",
      "cx": "976",
      "cy": "285",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_first_graph_1",
      "cx": "929",
      "cy": "325",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  })]), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "1134 218 912 218 912 93 1134 93",
      "transform": "rotate(180 1023 155.5)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "screen2_radar_bg_6",
      "cx": "1073",
      "cy": "154",
      "r": "50",
      "fill": "none",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "radar_path",
    attrs: {
      "id": "radar_path_1",
      "fill-rule": "nonzero",
      "stroke": "#FFF",
      "stroke-opacity": ".2",
      "d": "M1073 194.5c-22.37 0-40.5-18.13-40.5-40.5s18.13-40.5 40.5-40.5 40.5 18.13 40.5 40.5-18.13 40.5-40.5 40.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "radar_path",
    attrs: {
      "id": "radar_path_2",
      "fill-rule": "nonzero",
      "stroke": "#FFF",
      "stroke-opacity": ".2",
      "d": "M1073 184.5c-16.84 0-30.5-13.66-30.5-30.5s13.66-30.5 30.5-30.5 30.5 13.66 30.5 30.5-13.66 30.5-30.5 30.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "radar_path",
    attrs: {
      "id": "radar_path_3",
      "fill-rule": "nonzero",
      "stroke": "#FFF",
      "stroke-opacity": ".2",
      "d": "M1073 174.5c-11.32 0-20.5-9.18-20.5-20.5s9.18-20.5 20.5-20.5 20.5 9.18 20.5 20.5-9.18 20.5-20.5 20.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-opacity": ".2",
      "fill-rule": "nonzero",
      "d": "M1073 164.5c-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5 10.5 4.7 10.5 10.5-4.7 10.5-10.5 10.5zm0-1c5.25 0 9.5-4.25 9.5-9.5s-4.25-9.5-9.5-9.5-9.5 4.25-9.5 9.5 4.25 9.5 9.5 9.5z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "radar_point",
    attrs: {
      "id": "radar_point_1",
      "cx": "1073.5",
      "cy": "194.5",
      "r": "2.5",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "radar_point",
    attrs: {
      "id": "radar_point_2",
      "cx": "1073.5",
      "cy": "123.5",
      "r": "2.5",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "radar_point",
    attrs: {
      "id": "radar_point_3",
      "cx": "1052.5",
      "cy": "154.5",
      "r": "2.5",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M925,205.267564 C925.597801,205.613374 926,206.259718 926,207 C926,208.104569 925.104569,209 924,209 C922.895431,209 922,208.104569 922,207 C922,206.259718 922.402199,205.613374 923,205.267564 L923,105.732436 C922.402199,105.386626 922,104.740282 922,104 C922,102.895431 922.895431,102 924,102 C925.104569,102 926,102.895431 926,104 C926,104.740282 925.597801,105.386626 925,105.732436 L925,205.267564 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "40",
      "height": "4",
      "x": "924",
      "y": "197",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "60",
      "height": "4",
      "x": "924",
      "y": "187",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "83",
      "height": "4",
      "x": "924",
      "y": "178",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "63",
      "height": "4",
      "x": "924",
      "y": "168",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "27",
      "height": "4",
      "x": "924",
      "y": "158",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "75",
      "height": "4",
      "x": "924",
      "y": "149",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "48",
      "height": "4",
      "x": "924",
      "y": "139",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "66",
      "height": "4",
      "x": "924",
      "y": "129",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "80",
      "height": "4",
      "x": "924",
      "y": "120",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "18",
      "height": "4",
      "x": "924",
      "y": "110",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "472",
      "height": "266",
      "x": "394",
      "y": "93",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "845.26 94 846.2 94 846.2 358 845.26 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "792.62 94 793.56 94 793.56 358 792.62 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "737.16 94 738.1 94 738.1 358 737.16 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "683.58 94 684.52 94 684.52 358 683.58 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "630 94 630.94 94 630.94 358 630 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "575.48 94 576.42 94 576.42 358 575.48 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "521.9 94 522.84 94 522.84 358 521.9 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "467.38 94 468.32 94 468.32 358 467.38 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "413.8 94 414.74 94 414.74 358 413.8 358",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "794",
      "cy": "303.5",
      "stroke": "#FFF",
      "stroke-width": "6",
      "opacity": ".5",
      "rx": "38",
      "ry": "37.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-dasharray": "100",
      "stroke-width": "6",
      "d": "M757.670054,292.538968 C751.535729,312.339437 762.828346,333.298309 782.892821,339.35192 C802.957296,345.405531 824.19562,334.261501 830.329946,314.461032 C836.464271,294.660563 825.171654,273.701691 805.107179,267.64808 C785.042704,261.594469 763.80438,272.738499 757.670054,292.538968 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M793,317 C802.333333,312.415781 807,307.038169 807,300.867164 C807,293.518838 800.381217,290.14613 793,296.397727 C785.653874,289.865288 779,293.518838 779,300.867164 C779,307.038169 783.666667,312.415781 793,317 Z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "630",
      "cy": "303.5",
      "stroke": "#FFF",
      "stroke-width": "6",
      "opacity": ".66",
      "rx": "38",
      "ry": "37.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-dasharray": "84",
      "stroke-width": "6",
      "d": "M596.770533,321.677034 C606.943284,339.787686 630.067266,346.331135 648.419394,336.292237 C666.771522,326.253338 673.402217,303.433619 663.229467,285.322966 C653.056716,267.212314 629.932734,260.668865 611.580606,270.707763 C593.228478,280.746662 586.597783,303.566381 596.770533,321.677034 Z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#FFF",
      "points": "635.137 284 632.093 300.833 643 300.833 626.709 322 629.907 305.167 619 305.167",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "467",
      "cy": "303.5",
      "stroke": "#FFF",
      "stroke-width": "6",
      "opacity": ".5",
      "rx": "38",
      "ry": "37.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-dasharray": "190",
      "stroke-width": "6",
      "d": "M467,266 C446.01318,266 429,282.789322 429,303.5 C429,324.210678 446.01318,341 467,341 C487.98682,341 505,324.210678 505,303.5 C505,282.789322 487.98682,266 467,266 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M465.404437,317 C464.920427,317 464.505895,316.653366 464.420226,316.176999 L464.006549,313.87673 L460.875168,312.560004 L459.340998,313.488157 C458.960455,313.718381 458.473592,313.669603 458.146286,313.36846 L456.065874,311.454345 C455.745619,311.159689 455.652694,310.691745 455.836063,310.297079 L456.780737,308.263851 L455.767859,305.699553 L453.761803,305.207555 C453.314524,305.097857 453,304.696873 453,304.236338 L453,301.361783 C453,300.868035 453.360363,300.44819 453.848405,300.37334 L455.747048,300.082151 L457.001667,297.048804 L455.967038,295.447587 C455.711089,295.051475 455.766681,294.530382 456.100434,294.197181 L458.151712,292.149298 C458.473872,291.827671 458.972603,291.764218 459.365036,291.994929 L461.09282,293.010689 L464.015209,291.821184 L464.409916,289.807636 C464.501889,289.338446 464.91312,289 465.391239,289 L468.28795,289 C468.765033,289 469.175676,289.337014 469.26874,289.804932 L469.670389,291.824394 L472.79286,293.137117 L474.851229,291.999676 C475.268421,291.769138 475.790338,291.865098 476.098245,292.228952 L477.814456,294.257003 C478.076323,294.566452 478.125463,295.00338 477.938873,295.363265 L476.877774,297.409861 L477.915904,300.04272 L480.147752,300.376139 C480.637539,300.449309 481,300.869942 481,301.365164 L481,304.203351 C481,304.678935 480.665051,305.088725 480.198977,305.183355 L477.918716,305.646333 L476.616155,308.742698 L477.591365,310.700153 C477.784819,311.088458 477.705839,311.557207 477.395826,311.860682 L475.528989,313.688147 C475.194625,314.015459 474.678001,314.06716 474.285407,313.812598 L472.565892,312.697646 L469.670677,313.87564 L469.256686,316.177044 C469.170998,316.653391 468.756475,317 468.272483,317 L465.404437,317 Z M467,308.6 C470.092795,308.6 472.6,306.092795 472.6,303 C472.6,299.907205 470.092795,297.4 467,297.4 C463.907205,297.4 461.4,299.907205 461.4,303 C461.4,306.092795 463.907205,308.6 467,308.6 Z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M845.484581,240 C845.811025,239.402199 846.421173,239 847.12,239 C847.818827,239 848.428975,239.402199 848.755419,240 L866,240 L866,242 L848.755419,242 C848.428975,242.597801 847.818827,243 847.12,243 C846.421173,243 845.811025,242.597801 845.484581,242 L795.891419,242 C795.564975,242.597801 794.954827,243 794.256,243 C793.557173,243 792.947025,242.597801 792.620581,242 L740.195419,242 C739.868975,242.597801 739.258827,243 738.56,243 C737.861173,243 737.251025,242.597801 736.924581,242 L686.387419,242 C686.060975,242.597801 685.450827,243 684.752,243 C684.053173,243 683.443025,242.597801 683.116581,242 L632.579419,242 C632.252975,242.597801 631.642827,243 630.944,243 C630.245173,243 629.635025,242.597801 629.308581,242 L577.827419,242 C577.500975,242.597801 576.890827,243 576.192,243 C575.493173,243 574.883025,242.597801 574.556581,242 L524.019419,242 C523.692975,242.597801 523.082827,243 522.384,243 C521.685173,243 521.075025,242.597801 520.748581,242 L469.267419,242 C468.940975,242.597801 468.330827,243 467.632,243 C466.933173,243 466.323025,242.597801 465.996581,242 L415.459419,242 C415.132975,242.597801 414.522827,243 413.824,243 C413.125173,243 412.515025,242.597801 412.188581,242 L394,242 L394,240 L412.188581,240 C412.515025,239.402199 413.125173,239 413.824,239 C414.522827,239 415.132975,239.402199 415.459419,240 L465.996581,240 C466.323025,239.402199 466.933173,239 467.632,239 C468.330827,239 468.940975,239.402199 469.267419,240 L520.748581,240 C521.075025,239.402199 521.685173,239 522.384,239 C523.082827,239 523.692975,239.402199 524.019419,240 L574.556581,240 C574.883025,239.402199 575.493173,239 576.192,239 C576.890827,239 577.500975,239.402199 577.827419,240 L629.308581,240 C629.635025,239.402199 630.245173,239 630.944,239 C631.642827,239 632.252975,239.402199 632.579419,240 L683.116581,240 C683.443025,239.402199 684.053173,239 684.752,239 C685.450827,239 686.060975,239.402199 686.387419,240 L736.924581,240 C737.251025,239.402199 737.861173,239 738.56,239 C739.258827,239 739.868975,239.402199 740.195419,240 L792.620581,240 C792.947025,239.402199 793.557173,239 794.256,239 C794.954827,239 795.564975,239.402199 795.891419,240 L845.484581,240 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "28",
      "x": "825",
      "y": "213",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "38",
      "x": "799",
      "y": "203",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "59",
      "x": "772",
      "y": "183",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "87",
      "x": "745",
      "y": "155",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "95",
      "x": "718",
      "y": "146",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "118",
      "x": "691",
      "y": "123",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "131",
      "x": "665",
      "y": "110",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "124",
      "x": "638",
      "y": "117",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "118",
      "x": "611",
      "y": "123",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "131",
      "x": "584",
      "y": "110",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "108",
      "x": "557",
      "y": "134",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "87",
      "x": "531",
      "y": "154",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "95",
      "x": "504",
      "y": "146",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "75",
      "x": "477",
      "y": "166",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "59",
      "x": "450",
      "y": "182",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "12",
      "height": "51",
      "x": "423",
      "y": "190",
      "fill": "#FFF",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "470",
      "height": "131",
      "x": "394",
      "y": "397",
      "fill": "#6090B8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "112",
      "height": "30",
      "x": "742",
      "y": "486",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "112",
      "height": "30",
      "x": "742",
      "y": "448",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "112",
      "height": "30",
      "x": "742",
      "y": "409",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "107",
      "x": "630",
      "y": "409",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6090B8",
      "d": "M720,452 C715.581722,452 712,454.954921 712,458.6 L712,467.4 C712,471.045079 715.581722,474 720,474 L720,452 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "107",
      "x": "518",
      "y": "409",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6090B8",
      "d": "M528,452 C532.418278,452 536,454.954921 536,458.6 L536,467.4 C536,471.045079 532.418278,474 528,474 L528,452 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "107",
      "x": "406",
      "y": "409",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6090B8",
      "d": "M496,452 C491.581722,452 488,454.954921 488,458.6 L488,467.4 C488,471.045079 491.581722,474 496,474 L496,452 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "490",
      "height": "11.167",
      "x": "384",
      "y": "386",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "1221",
      "cy": "520",
      "r": "8",
      "fill": "#5585AE"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "1155",
      "cy": "520",
      "r": "8",
      "fill": "#5585AE"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6090B8",
      "d": "M1144,500 L1233,500 C1238.52285,500 1243,504.477153 1243,510 L1243,515 L1134,515 L1134,510 C1134,504.477153 1138.47715,500 1144,500 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "15",
      "height": "38",
      "x": "1181",
      "y": "462",
      "fill": "#5585AE"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#5585AE",
      "d": "M1215.5,368 C1220.19442,368 1224,371.872132 1224,376.648649 L1224,439.351351 C1224,444.127868 1220.19442,448 1215.5,448 C1210.80558,448 1207,444.127868 1207,439.351351 L1207,376.648649 C1207,371.872132 1210.80558,368 1215.5,368 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "109",
      "height": "22",
      "x": "1134",
      "y": "440",
      "fill": "#6A9BC4",
      "rx": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "65",
      "height": "90",
      "x": "1184",
      "y": "328",
      "fill": "#6090B8",
      "rx": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "65",
      "height": "90",
      "x": "1173",
      "y": "328",
      "fill": "#6A9BC4",
      "rx": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-linecap": "square",
      "stroke-width": "2",
      "d": "M1134.5 295L1279.5 295M1134.5 155L1279.5 155M885.5 55.5L885.5 284.5C885.5 290.022847 889.977153 294.5 895.5 294.5L911.5 294.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-linecap": "square",
      "stroke-width": "2",
      "d": "M325.5,105.5 L325.5,65.4013672 C325.5,59.8785197 329.977153,55.4013672 335.5,55.4013672 L1013.5,55.4013672 C1019.02285,55.4013672 1023.5,59.8785197 1023.5,65.4013672 L1023.5,92.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "156",
      "height": "44",
      "x": "203",
      "y": "484",
      "fill": "#EDEDED"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "156",
      "height": "334",
      "x": "203",
      "y": "150",
      "fill": "#FFF",
      "opacity": ".3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#EDEDED",
      "points": "203 105 274 105 274 0 288 0 288 105 359 105 359 150 203 150"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "266",
      "cy": "127",
      "r": "5",
      "fill": "#A3E263"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "246",
      "cy": "127",
      "r": "5",
      "fill": "#F5CA23"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "226",
      "cy": "127",
      "r": "5",
      "fill": "#E3374C"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "30",
      "height": "70",
      "x": "440",
      "y": "316",
      "fill": "#A2C5E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M451.538462,346.333333 L458.461538,346.333333 C459.736042,346.333333 460.769231,347.378002 460.769231,348.666667 L460.769231,374.333333 C460.769231,375.621998 459.736042,376.666667 458.461538,376.666667 L451.538462,376.666667 C450.263958,376.666667 449.230769,375.621998 449.230769,374.333333 L449.230769,348.666667 C449.230769,347.378002 450.263958,346.333333 451.538462,346.333333 Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "455",
      "cy": "331.167",
      "fill": "#4E7CA2",
      "rx": "5.769",
      "ry": "5.833"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "30",
      "height": "70",
      "x": "404",
      "y": "316",
      "fill": "#A2C5E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M415.538462,346.333333 L422.461538,346.333333 C423.736042,346.333333 424.769231,347.378002 424.769231,348.666667 L424.769231,374.333333 C424.769231,375.621998 423.736042,376.666667 422.461538,376.666667 L415.538462,376.666667 C414.263958,376.666667 413.230769,375.621998 413.230769,374.333333 L413.230769,348.666667 C413.230769,347.378002 414.263958,346.333333 415.538462,346.333333 Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "419",
      "cy": "331.167",
      "fill": "#4E7CA2",
      "rx": "5.769",
      "ry": "5.833"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "20.16",
      "height": "24.621",
      "x": "579",
      "y": "361.345",
      "fill": "#4E7CA2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M582,358.448276 L591.84,358.448276 C593.496854,358.448276 594.84,359.791422 594.84,361.448276 L594.84,369.331034 C594.84,371.31926 593.228225,372.931034 591.24,372.931034 L591.24,372.931034 C589.251775,372.931034 587.64,371.31926 587.64,369.331034 L587.64,365.689655 L579,365.689655 L579,361.448276 C579,359.791422 580.343146,358.448276 582,358.448276 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6090B8",
      "d": "M599.16 361.344828L611.37931 361.344828C613.378962 361.344828 615 362.965866 615 364.965517L615 364.965517C615 366.965169 613.378962 368.586207 611.37931 368.586207L599.16 368.586207 599.16 361.344828zM599.16 370.034483L611.37931 370.034483C613.378962 370.034483 615 371.655521 615 373.655172L615 373.655172C615 375.654824 613.378962 377.275862 611.37931 377.275862L599.16 377.275862 599.16 370.034483zM599.16 378.724138L611.37931 378.724138C613.378962 378.724138 615 380.345176 615 382.344828L615 382.344828C615 384.344479 613.378962 385.965517 611.37931 385.965517L599.16 385.965517 599.16 378.724138z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#5585AE",
      "d": "M480.499227,362.092589 L578.729768,357.167285 C580.384543,357.084314 581.793265,358.358513 581.876236,360.013289 C581.878745,360.063327 581.88,360.11342 581.88,360.163521 L581.88,383.196975 C581.88,384.853829 580.536854,386.196975 578.88,386.196975 L481,386.196975 C475.477153,386.196975 471,381.719822 471,376.196975 L471,372.080042 C471,366.751841 475.177711,362.359411 480.499227,362.092589 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#A2C5E2",
      "d": "M501.142197,331.123437 L527.623204,328.716072 C542.691701,327.346209 556.017625,338.451146 557.387488,353.519643 C557.462458,354.344303 557.5,355.171939 557.5,356 L557.5,356 C557.5,372.568542 544.068542,386 527.5,386 L501.25,386 C486.752525,386 475,374.247475 475,359.75 L475,359.75 C475,344.883195 486.336446,332.469414 501.142197,331.123437 Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "485.75",
      "cy": "360.5",
      "fill": "#6A9BC4",
      "rx": "8.25",
      "ry": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#5585AE",
      "d": "M519.360651,333.788784 L527.802113,332.819337 C540.950517,331.309329 552.833509,340.744113 554.343517,353.892518 C554.447754,354.800161 554.5,355.713021 554.5,356.62663 L554.5,356.62663 C554.5,371.468382 542.468382,383.5 527.62663,383.5 L519.514199,383.5 C506.527665,383.5 496,372.972335 496,359.985801 L496,359.985801 C496,346.586503 506.04885,335.317557 519.360651,333.788784 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "160",
      "height": "200",
      "y": "92",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "110",
      "height": "110",
      "y": "312",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "50",
      "height": "70",
      "x": "133",
      "y": "122",
      "fill": "#A2C5E2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "20",
      "height": "20",
      "x": "136",
      "y": "202",
      "fill": "#A2C5E2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "20",
      "height": "20",
      "x": "147",
      "y": "227",
      "fill": "#A2C5E2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "65",
      "x": "879",
      "y": "463",
      "fill": "#6090B8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4E7CA2",
      "d": "M919,468 L939,468 C941.761424,468 944,470.238576 944,473 C944,475.761424 941.761424,478 939,478 L919,478 C916.238576,478 914,475.761424 914,473 C914,470.238576 916.238576,468 919,468 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "80",
      "height": "38",
      "x": "889",
      "y": "484",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "110",
      "height": "15",
      "x": "874",
      "y": "448",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "65",
      "x": "895",
      "y": "383",
      "fill": "#6090B8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4E7CA2",
      "d": "M935,388 L955,388 C957.761424,388 960,390.238576 960,393 C960,395.761424 957.761424,398 955,398 L935,398 C932.238576,398 930,395.761424 930,393 C930,390.238576 932.238576,388 935,388 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "80",
      "height": "38",
      "x": "905",
      "y": "404",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "110",
      "height": "15",
      "x": "890",
      "y": "368",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "100",
      "height": "65",
      "x": "980",
      "y": "463",
      "fill": "#6090B8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4E7CA2",
      "d": "M1020,468 L1040,468 C1042.76142,468 1045,470.238576 1045,473 C1045,475.761424 1042.76142,478 1040,478 L1020,478 C1017.23858,478 1015,475.761424 1015,473 C1015,470.238576 1017.23858,468 1020,468 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "80",
      "height": "38",
      "x": "990",
      "y": "484",
      "fill": "#6A9BC4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4E7CA2",
      "d": "M1020 439L1060 439C1071.04569 439 1080 447.954305 1080 459L1080 463 1000 463 1000 459C1000 447.954305 1008.95431 439 1020 439zM948.441583 517.254308L960.051807 511.247652 983.208434 510.055556 983.754549 520.291508C983.855086 522.175895 982.381451 523.783551 980.463093 523.882307L949.201646 525.491638C947.283289 525.590394 945.646651 524.142855 945.546114 522.258468 945.435141 520.178474 946.565491 518.224921 948.441583 517.254308z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#6A9BC4",
      "d": "M984.141355,448.623654 L985.25711,447.472717 C989.176279,443.429966 995.134879,444.221452 999.736816,447.472717 L1024,463 L992.033385,463 L986.835935,460.964866 C982.917999,459.430742 980.990356,455.023237 982.530425,451.120426 C982.897295,450.190711 983.444728,449.342248 984.141355,448.623654 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#A2C5E2",
      "d": "M996.364987,445.473953 L996.817921,445.618514 C1002.72081,447.502514 1005.95122,453.730294 1004.03326,459.52865 L985.292646,516.184955 C984.699028,517.979573 982.736752,518.961697 980.909782,518.37859 L961.061356,512.043649 C959.234385,511.460543 958.234556,509.533016 958.828175,507.738398 C958.854842,507.657778 958.884555,507.57816 958.917251,507.49971 L982.05236,451.990443 C984.351713,446.473486 990.593152,443.63178 996.364987,445.473953 Z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#6A9BC4",
      "points": "1076.935 417.223 1101.68 524.403 1087.065 527.777 1062.32 420.597"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "1120 -1 1135 -1 1135 30 1120 30"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1095.61553,30 L1281,30 L1281,70 L1070,70 L1076.21268,45.1492875 C1078.43851,36.2459475 1086.43818,30 1095.61553,30 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1062.5,65 L1281,65 L1281,70 L1062.5,70 C1061.11929,70 1060,68.8807119 1060,67.5 L1060,67.5 C1060,66.1192881 1061.11929,65 1062.5,65 Z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "521 -1 536 -1 536 30 521 30"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "726 -1 741 -1 741 30 726 30"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M496.615528,30 L765.384472,30 C774.561825,30 782.561487,36.2459475 784.787322,45.1492875 L791,70 L471,70 L477.212678,45.1492875 C479.438513,36.2459475 487.438175,30 496.615528,30 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "340",
      "height": "5",
      "x": "461",
      "y": "65",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "points": "145 -1 160 -1 160 30 145 30"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M-1,30 L184.384472,30 C193.561825,30 201.561487,36.2459475 203.787322,45.1492875 L210,70 L-1,70 L-1,30 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M-1,65 L217.5,65 C218.880712,65 220,66.1192881 220,67.5 L220,67.5 C220,68.8807119 218.880712,70 217.5,70 L-1,70 L-1,65 Z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ce3fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_5/svg/scene/backgrounds/lab_background.vue
// module id = 798
// module chunks = 1